/* libs */
import { createLogic } from "redux-logic";
/* action helpers */
import * as ActionTypes from "../../actions/actionTypes";
import * as controlPanelActions from "../../actions/controlPanelActions";
import ErrorHandler from "../../helpers/validation/errorHandler";

const createThemesFailureLogic = createLogic({
	type: ActionTypes.DELETE_THEME_FAILURE,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		ErrorHandler(action.errorMessage, null, controlPanelActions, dispatch);
		done();
	},
});

export default [createThemesFailureLogic];
